/**
 * Sections ("categories") on the Water Well Technician Training page.
 * Each week of a section is a Library item with `manualSection` set to the
 * section id and `manualWeek` set to its week number. Add a new section here
 * to get a new category on the page.
 */
export interface ManualSection {
  id: string;
  title: string;
  description: string;
}

export const MANUAL_SECTIONS: ManualSection[] = [
  {
    id: 'flowcore_water_training_manual',
    title: 'Flowcore Water Training Manual',
    description: 'Weekly training material for water well technicians.',
  },
];

export const getManualSection = (id: string | null | undefined): ManualSection | undefined =>
  MANUAL_SECTIONS.find((s) => s.id === id);

export const MANUAL_PAGE_PATH = '/water-well-technician-training';
